import React from 'react'
import { Container } from 'react-bootstrap'

export default function Visualization() {
  return (
    <Container className="my-3">      
      <iframe title="Alida Viz" className="iframe-container" src={window.__env.VIZ_URL} />
    </Container>
  )
}
